module.exports = __webpack_public_path__ + "static/img/medicalb.7f3af52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medicalb.png
// module id = 43SU
// module chunks = 1